module.exports = __webpack_public_path__ + "img/ic_sign_up_mobile.f2749165.svg";